var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTransfer = function SvgTransfer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M23.21 24.255c-.284-.565-.86-.922-1.492-.922h-5v-6.667c0-.92-.745-1.666-1.667-1.666H8.384c-.92 0-1.666.746-1.666 1.666v6.667h-5c-.63 0-1.207.357-1.49.922-.282.565-.222 1.24.158 1.745l10 13.333c.313.42.808.667 1.332.667.525 0 1.02-.247 1.333-.667l10-13.333c.38-.505.44-1.18.158-1.745z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M15.052 10H8.385c-.921 0-1.666.745-1.666 1.667 0 .921.745 1.666 1.666 1.666h6.667c.921 0 1.666-.745 1.666-1.666 0-.922-.745-1.667-1.666-1.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5E6FF",
    d: "M15.052 5H8.385c-.921 0-1.666.745-1.666 1.667 0 .921.745 1.666 1.666 1.666h6.667c.921 0 1.666-.745 1.666-1.666 0-.922-.745-1.667-1.666-1.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FF",
    d: "M15.052 0H8.385C7.464 0 6.72.745 6.72 1.667c0 .921.745 1.666 1.666 1.666h6.667c.921 0 1.666-.745 1.666-1.666C16.718.745 15.974 0 15.052 0z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer.4c91e291.svg";
export { ForwardRef as ReactComponent };